import cn from 'classnames';
import React from 'react';

import {ButtonRaw} from '@/components/Button';
import helpers from '@/utils/helpers';
import {twx} from '@/utils/tailwindUtils';

import styles from './SwitchToggle.module.scss';

// TODO: Replace with radix ui switch

const SwitchToggle = ({
    onChange,
    className,
    isActive,
    testId,
    'aria-labelledby': ariaLabelledBy,
    isDisabled,
    secondary,
    onDisableClick,
    ...rest
}) => {
    const onSwitchToggleClick = () => {
        if (isDisabled) {
            onDisableClick?.();
            return;
        }
        helpers.runFunction(onChange, !isActive);
    };

    return (
        <ButtonRaw
            className={twx(
                'flex cursor-pointer items-center justify-center py-2 md:block md:p-0 md:pr-4',
                {'cursor-default opacity-60': isDisabled},
                className
            )}
            data-testid={testId}
            onClick={onSwitchToggleClick}
            role='switch'
            aria-labelledby={ariaLabelledBy}
            aria-checked={!!isActive}
            tabIndex={isDisabled ? -1 : 0}
            {...rest}
        >
            <div className={cn(styles.Toggle, {[styles.Active]: isActive}, {[styles.VariantSecondary]: secondary})}>
                <div className={styles.Slider} />
            </div>
        </ButtonRaw>
    );
};

export default SwitchToggle;
